import { normalize } from 'normalizr'
import { isEmpty } from 'lodash'

import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import { API } from 'utils/helpers/api/api'
import { formatRequestString, formatQueryString } from 'utils/helpers/api/queryString'

export const makeCreateItemActionCreator =
  ({
    entityUrl,
    entityKey,
    entitySchema,
    skipStoreUpdate = false,
    transformRequestFunction = data => data,
    transformResponseFunction = data => data,
  }) =>
  params =>
  dispatch => {
    const { formData } = params
    const requestString = formatRequestString({ entityUrl, params })
    const requestQueryString = formatQueryString(params)
    const requestUrl = isEmpty(requestQueryString) ? requestString : `${requestString}?${requestQueryString}`
    const requestData = transformRequestFunction(formData, params)

    return API.post(requestUrl, requestData).then(payload => {
      const dataTransformed = transformResponseFunction(payload.data, params)
      const data = normalize({ [entityKey]: [dataTransformed] }, { [entityKey]: [entitySchema] })

      if (!skipStoreUpdate) {
        dispatch({
          type: ACTION_TYPES.ITEM_FETCH_SUCCESS,
          data,
        })
      }

      return dataTransformed
    })
  }
